module.exports = __webpack_public_path__ + "static/Dark-Green-c9948892da8a22c476d98c9dd819be5b.png";